const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentText extends HTMLDivElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {
		if (this.initialized) {
			return;
		}
		this.initialized = true;
		const tableElements = this.querySelectorAll('table');
		for (const tableElement of tableElements) {
			const wrapperElement = document.createElement('div');
			wrapperElement.classList.add('table-wrapper');
			this.wrap(tableElement, wrapperElement);
		}
	}

	wrap(element, wrapperElement) {
		element.parentNode.insertBefore(wrapperElement, element);
		wrapperElement.appendChild(element);
	}

}

customElements.define('component-text', ComponentText, {extends: 'div'});